<template>
    <div class="modal fade" tabindex="-1" role="dialog">

        <!-- modal-add-update-credit-card -->
        <modal-guest-register 
            v-if="requestedModal === 'guestRegister'"
            ref="activeModalRef"
            :lang="lang"
            :modal-data="modalData"
        ></modal-guest-register>

        <!-- modal-add-update-credit-card -->
        <modal-single-maps-location 
            v-if="requestedModal === 'singleMapsLocation'"
            ref="activeModalRef"
            :lang="lang"
            :modal-data="modalData"
        ></modal-single-maps-location>
        
    </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import _ from 'lodash';

import ModalGuestRegister from './ModalGuestRegister.vue';
import ModalSingleMapsLocation from './ModalSingleMapsLocation.vue';

const requestedModal = ref('');
const lang = ref({});
const modalData = ref({});
const activeModalRef = ref(null);

/**
 * load a modal
 */
const loadModal = (newRequestedModal, modalDataValue) => {
    if (newRequestedModal === '') {
        return;
    }

    modalData.value = (modalDataValue !== undefined) ? modalDataValue : {};

    if (_.isEmpty(lang.value)) {
        // load language data
        axios.get(`/web-api/language`, {
                params: {
                    section: 'modal'
                }
            })
            .then(response => {
                lang.value = response.data.lang;
                requestedModal.value = newRequestedModal;
                renderModal();
            })
            .catch(
                // error => console.log(error)
            );
    } else {
        requestedModal.value = newRequestedModal;
        renderModal();
    }
};

/**
 * render modal
 */
const renderModal = () => {
    setTimeout(() => {
        if (activeModalRef.value) {
            activeModalRef.value.showModal();
        }
    }, 300);
};

/**
 * hide Modal
 */
const hideModal = () => {
    if (activeModalRef.value) {
        activeModalRef.value.hideModal();
    }
};

defineExpose({
    loadModal,
    hideModal,
});
</script>
